import { TAGS_HIERARCHY_PATH } from 'apps/navigation/constants';
import { filterQueryParametersAndReplace } from 'utils/url';
import gtmPageTypes from 'apps/gtm/utils/gtmPageTypes';

import tagRedirects from 'apps/tagRedirects/routes/tagRedirects';
import {
  redirectCatatalogueToBrowse,
  redirectSearchWithoutEntryInQueryToBrowser,
  redirectUrlWithTagsInQuery,
} from './routesRedirects';

export default [
  {
    path: `search${TAGS_HIERARCHY_PATH}`,
    onEnterHandlers: [
      redirectSearchWithoutEntryInQueryToBrowser,
    ],
    getComponent(location, callback) {
      import(/* webpackChunkName: "search" */ './containers/SearchResultsPage')
        .then(component => callback(null, component.default));
    },
    gtmPageType: gtmPageTypes.Search,
    layoutSidebarLeft: true,
  },
  {
    path: `browse${TAGS_HIERARCHY_PATH}`,
    onEnterHandlers: [
      redirectUrlWithTagsInQuery,
      tagRedirects,
    ],
    getComponent(location, callback) {
      import(/* webpackChunkName: "browse" */ './containers/BrowseCataloguePage')
        .then(component => callback(null, component.default));
    },
    gtmPageType: gtmPageTypes.Catalogue,
    layoutSidebarLeft: true,
  },
  {
    path: `catalogue${TAGS_HIERARCHY_PATH}`, // alias only
    onEnterHandlers: [
      redirectCatatalogueToBrowse,
    ],
  },
  {
    path: `on-offer${TAGS_HIERARCHY_PATH}`,
    getComponent(location, callback) {
      import(/* webpackChunkName: "on-offer" */ './containers/OnOfferPage')
        .then(component => callback(null, component.default));
    },
    gtmPageType: gtmPageTypes.Offers,
    layoutSidebarLeft: true,
  },
  {
    path: 'offers',
    onEnterHandlers: [
    ],
    indexRoute: {
      onEnterHandlers: [
        filterQueryParametersAndReplace('/on-offer'),
      ],
    },
    childRoutes: [
      {
        path: ':id',
        getComponent(location, callback) {
          import(/* webpackChunkName: "on-offer" */ './containers/OfferDetailsPage')
            .then(component => callback(null, component.default));
        },
      },
    ],
    gtmPageType: gtmPageTypes.Offers,
    layoutSidebarRight: true,
  },
  {
    path: 'your-savings-hub',
    onEnterHandlers: [
      redirectUrlWithTagsInQuery,
      tagRedirects,
    ],
    getComponent(location, callback) {
      import(/* webpackChunkName: "savings-hub" */ './containers/YourSavingsHubPage')
        .then(component => callback(null, component.default));
    },
    gtmPageType: gtmPageTypes.SAVINGS_HUB,
    layoutSidebarLeft: true,
  },
];
